export function useFlyToCart() {
  function flyToCart(sourceElement: HTMLElement | null | undefined): void {
    if (!sourceElement) return;

    const cartIcon = document.querySelector("[data-cart-icon]") as HTMLElement | null;
    if (!cartIcon) return;

    const sourceRect = sourceElement.getBoundingClientRect();
    const targetRect = cartIcon.getBoundingClientRect();
    const sourceImg = sourceElement.querySelector("img");

    const clone = document.createElement("div");

    const FLY_SIZE = 40;
    const targetCenterX = targetRect.left + targetRect.width / 2 - FLY_SIZE / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2 - FLY_SIZE / 2;

    clone.className =
      "fixed overflow-hidden pointer-events-none z-[9999] rounded-lg opacity-100 [will-change:left,top,width,height,opacity,border-radius]";
    clone.style.left = `${sourceRect.left}px`;
    clone.style.top = `${sourceRect.top}px`;
    clone.style.width = `${sourceRect.width}px`;
    clone.style.height = `${sourceRect.height}px`;

    if (sourceImg) {
      const imgClone = sourceImg.cloneNode(true) as HTMLImageElement;
      imgClone.className = "w-full h-full object-contain";
      clone.appendChild(imgClone);
    } else {
      clone.classList.add("bg-primary");
    }

    document.body.appendChild(clone);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        clone.classList.add("transition-all", "duration-[750ms]", "ease-in-out");

        clone.style.left = `${targetCenterX}px`;
        clone.style.top = `${targetCenterY}px`;
        clone.style.width = `${FLY_SIZE}px`;
        clone.style.height = `${FLY_SIZE}px`;
        clone.classList.replace("opacity-100", "opacity-0");
        clone.classList.replace("rounded-lg", "rounded-full");
      });
    });

    clone.addEventListener("transitionend", (event) => {
      if (event.propertyName === "opacity") {
        clone.remove();
      }
    });
  }

  return { flyToCart };
}
